export function changeLoading(loading) {
	return {
		type: "@recover/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

/**
 *
 * @param {{ vlDocument: string, documentType: string, recoveryInfoType: "phone_mobile" | "email", recoveryInfo: string, operatingSystem: string, header: object, isResendCode?: boolean }} payload
 * @returns
 */
export function requestAccountRecoverWithTypeRequest(payload) {
	return {
		type: "@recover/REQUEST_ACCOUNT_RECOVER_WITH_TYPE_REQUEST",
		payload,
	};
}

/**
 *
 * @param {{baseInfoVl: string, baseInfoType: string, recoverChannel: string, cdChannel: string, operatingSystem: string}} data
 * @param {{[key:string]: string}} header
 * @returns
 */
export function requestAccountRecoverWithTypeME(data, header) {
	return {
		type: "@recover/REQUEST_ACCOUNT_RECOVER_WITH_TYPE_ME",
		payload: { data, header },
	};
}

export function respAccountRecoverWithType(data) {
	return {
		type: "@recover/ACCOUNT_RECOVER_WITH_TYPE_RESPONSE",
		payload: { data },
	};
}

export function showMessageRecoverFailed(error, obj) {
	return {
		type: "@recover/SHOW_MESSAGE_RECOVER_FAILED",
		payload: { error, ...obj },
	};
}

/**
 * @param {{token: string, type: "phone_mobile" | "email", value: string, vlDocument: string}} payload
 * @returns
 */
export function doRecoverAccountWithTypeRequest(payload) {
	return {
		type: "@recover/DO_RECOVER_ACOUNT_WITH_TYPE_REQUEST",
		payload,
	};
}

export function recoverPinCodeFailed(param) {
	return {
		type: "@recover/RECOVER_PIN_CODE_FAILED",
		payload: { param },
	};
}

export function changePasswordAfterValidate(token, newPassword, newConfirmPassword) {
	return {
		type: "@recover/CHANGE_PASSWORD_AFTER_VALIDATE",
		payload: { token, newPassword, newConfirmPassword },
	};
}

export function sendToken(token) {
	return {
		type: "@recover/SEND_TOKEN",
		payload: { token },
	};
}
